var Component = require("!../../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  null,
  /* template */
  require("!!../../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-2c8dfc72\"}!../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./tags-not-loaded.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./modules/repositories/components/tags-not-loaded.vue
// module id = 78
// module chunks = 0